import React, { Component } from "react";
import "./index.css";
import { connect } from "react-redux";
import defaultImage from "../../../Assets/img/default-avatar.png";

const mapStateToProps = ({ dispatch, user }) => ({
  dispatch,
  user,
});
class ProfileCard extends Component {
  render() {
    if (this.props.user.role.id === 9) {
      return (
        <div className="d-flex align-items-center py-4 container col-12  mb-2">
          <div className="th-home-img-wrap">
            {this.props.user.studentData.student_photo ? (
              <div
                className="th-home-img"
                style={{
                  backgroundImage: `url('${this.props.user?.studentData?.student_photo}')`,
                }}
              ></div>
            ) : (
              <div
                className="th-home-img"
                style={{
                  backgroundImage: `url('${defaultImage}')`,
                }}
              ></div>
            )}
          </div>
          <div className="pl-3">
            <div className="th-14 th-medium">
              {this.props.user?.user?.first_name}
              {this.props.user?.user?.last_name}
            </div>
            <div className="th-12">
              {this.props.user.user.username} |{" "}
              {this.props.user.student_class.class_name} |{" "}
              {this.props.user.student_section.section_name}
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="d-flex align-items-center py-4 container col-12">
          <div className="th-home-img-wrap">
            {this.props.user?.staffData?.staff_image ? (
              <div
                className="th-home-img"
                style={{
                  backgroundImage: `url('${this.props.user?.staffData?.staff_image}')`,
                }}
              ></div>
            ) : (
              <div
                className="th-home-img"
                style={{
                  backgroundImage: `url('${defaultImage}')`,
                }}
              ></div>
            )}
          </div>
          <div className="pl-3">
            <div className="th-12 th-medium">
              {this.props.user.user.first_name}
            </div>
            <div className="th-12">{this.props.user.user.username}</div>
          </div>
        </div>
      );
    }
  }
}

export default connect(mapStateToProps)(ProfileCard);
